import Vue from 'vue'
import Router from 'vue-router'
import Order from '@/components/order/Order.vue'
import Position from '@/components/position/Position.vue'
import Holding from '@/components/holding/Holding.vue'
import SignUp from '@/components/user/SignUp.vue'
import signIn from '@/components/user/SignIn.vue'
import Profile from '@/components/profile/Profile.vue'
import Report from '@/components/report/Report.vue'
import FundsReport from '@/components/report/FundsReport.vue'
import SharedMonthReport from '@/components/report/SharedMonthReport.vue'
import MarketWatchNav from '@/components/marketwatch/MarketWatchNav'
import Chart from '@/components/chart/Chart'
import ProcessTemplate from '@/components/user/ProcessTemplate.vue'
import More from '@/components/android/More.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'NavBar',
      component: Order
    },
    {
      path: '/holdings',
      name: 'holdings',
      component: Holding
    },
    {
      path: '/orders',
      name: 'orders',
      component: Order
    },
    {
      path: '/positions',
      name: 'positions',
      component: Position
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/signin',
      name: 'signin',
      component: signIn
    },
    {
      path: '/fundsreport',
      name: 'fundsreport',
      component: FundsReport
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/mw',
      name: 'mw',
      component: MarketWatchNav
    },
    {
      path: '/chart',
      name: 'chart',
      component: Chart
    },
    {
      path: '/share/report/month',
      name: 'report',
      component: SharedMonthReport
    },
    {
      path: '/processtemplate',
      name: 'processtemplate',
      component: ProcessTemplate
    },
    {
      path: '/more',
      name: 'more',
      component: More
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js